import { SizeSelector } from '../../components/SizeSelector';

const sizeSelector = () => {
  const sizeSelectorInstance = new SizeSelector(document.querySelector('#pdp-atc-size-selector'), {
    formVariantId: document.querySelector('form input[name="id"]'),
    sizeLabelValue: document.querySelector('.pdp-c-atc-size-selector__value'),
    priceValue: document.querySelector('.pdp-c-atc-price-tag__regular'),
    incentives: document.querySelector('.pdp-c-incentives__free-shipping-label'),
    almostGoneMessage: document.querySelector('.pdp-c-gallery__almost-gone'),
    productJSONData: JSON.parse(document.querySelector('[data-product-json]').innerHTML),
    priceTag: document.querySelector('div.pdp-c-atc-price-tag'),
  });
  sizeSelectorInstance.init();
};

export default sizeSelector;
